import React from 'react';
import { InterPoint } from '@saviynt/common';

import SodApplicationGroup from '../SodApplicationGroup';

interface SodEndPointChipProps {
  endpoints: {
    endpointName: string | null;
    endpointLogo: string | null;
  }[];
  isPrefixInterpoint?: boolean;
}

/**
 * SodEndPointChip
 */
function SodEndPointChip({
  endpoints,
  isPrefixInterpoint,
}: SodEndPointChipProps) {
  const endpointCount = endpoints.length;

  if (endpointCount === 0) {
    return null;
  }

  if (endpointCount === 1) {
    const { endpointName, endpointLogo } = endpoints[0];

    if (endpointName !== null) {
      return (
        <>
          <SodApplicationGroup
            label={endpointName}
            firstLogo={endpointLogo ?? undefined}
          />
          {isPrefixInterpoint && (
            <InterPoint color='neutralBold' font='body2' />
          )}
        </>
      );
    }

    return null;
  }

  const validEndpoints = endpoints.filter(
    (ep) =>
      typeof ep.endpointName === 'string' && ep.endpointName.trim().length > 0
  );
  const validEndpointCount = validEndpoints.length;
  const [firstEndpoint, secondEndpoint] = validEndpoints;

  if (firstEndpoint.endpointName) {
    return (
      <>
        <SodApplicationGroup
          label={firstEndpoint.endpointName}
          firstLogo={firstEndpoint.endpointLogo ?? undefined}
          secondLogo={secondEndpoint.endpointLogo ?? undefined}
          count={validEndpointCount}
        />
        {isPrefixInterpoint && <InterPoint color='neutralBold' font='body2' />}
      </>
    );
  }

  return null;
}

SodEndPointChip.defaultProps = {
  isPrefixInterpoint: true,
};

export default SodEndPointChip;
